// extracted by mini-css-extract-plugin
module.exports = {"title":"src-components-FormResponse-FormEditWarning-styles___title","list":"src-components-FormResponse-FormEditWarning-styles___list"};